import { render, staticRenderFns } from "./CoverLetterReview.vue?vue&type=template&id=018247f9"
import script from "./CoverLetterReview.vue?vue&type=script&lang=js"
export * from "./CoverLetterReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports